export default {
  // Common
  'crm.common.actions': 'Actions',
  'crm.common.view': 'View',
  'crm.common.edit': 'Edit',
  'crm.common.delete': 'Delete',
  'crm.common.create': 'Create',
  'crm.common.save': 'Save',
  'crm.common.cancel': 'Cancel',
  'crm.common.confirm': 'Confirm',
  'crm.common.search': 'Search',
  'crm.common.reset': 'Reset',
  'crm.common.status': 'Status',
  'crm.common.createdAt': 'Created At',
  'crm.common.updatedAt': 'Updated At',
  'crm.common.enable': 'Enable',
  'crm.common.disable': 'Disable',
  'crm.common.yes': 'Yes',
  'crm.common.no': 'No',
  'crm.common.all': 'All',
  'crm.common.loading': 'Loading...',
  'crm.common.noData': 'No Data',
  'crm.common.total': 'Total',
  'crm.common.selected': 'Selected',
  'crm.common.items': 'items',
  'crm.common.export': 'Export',
  'crm.common.import': 'Import',
  'crm.common.refresh': 'Refresh',
  'crm.common.back': 'Back',
  'crm.common.detail': 'Detail',
  'crm.common.title': 'Title',
  'crm.common.success': 'Operation successful',
  'crm.common.createFailed': 'Create failed',
  'crm.common.updateFailed': 'Update failed',
  'crm.common.deleteFailed': 'Delete failed',
  'crm.common.operationFailed': 'Operation failed',
  'crm.common.onlyImageAllowed': 'Only image files are allowed',
  'crm.common.imageTooLarge': 'Image must be smaller than 5MB',
  'crm.timezone.local': 'Local',
  'crm.timezone.utc': 'UTC',
  'crm.timezone.tooltip': 'Switch time display timezone',

  // Dashboard
  'crm.dashboard.title': 'Dashboard',
  'crm.dashboard.totalUsers': 'Total Users',
  'crm.dashboard.paidUsers': 'Paid Users',
  'crm.dashboard.activeMiners': 'Active Miners',
  'crm.dashboard.pendingWithdrawals': 'Pending Withdrawals',
  'crm.dashboard.userGrowth': 'User Growth (7 Days)',
  'crm.dashboard.revenueTrend': 'Revenue (USDT) (7 Days)',
  'crm.dashboard.userDistribution': 'User Distribution',
  'crm.dashboard.recentActivities': 'Recent Activities',
  'crm.dashboard.fromYesterday': 'from yesterday',
  'crm.dashboard.paidRate': 'Paid Rate',
  'crm.dashboard.thisWeek': 'this week',
  'crm.dashboard.total': 'Total',
  'crm.dashboard.minerTypesDistribution': 'Miner Types Distribution',
  'crm.dashboard.standardType': 'Standard Type',
  'crm.dashboard.newUserType': 'New User Type',
  'crm.dashboard.recentWithdrawals': 'Recent Withdrawals',
  'crm.dashboard.viewAll': 'View All',
  'crm.dashboard.todayRevenue': 'Today Revenue',
  'crm.dashboard.todayRegistrations': 'Today Registrations',
  'crm.dashboard.activeSessions': 'Active Sessions',
  'crm.dashboard.todayStartedSessions': 'Today Mining Started',
  'crm.dashboard.claimableSessions': 'Pending Claim',
  'crm.dashboard.totalCommissionPaid': 'Total Commission Paid',
  'crm.dashboard.todayRefunds': 'Today Refunds',
  'crm.dashboard.totalRefunds': 'Total Refunds',
  'crm.dashboard.refundOrders': 'Refunded Orders',
  'crm.dashboard.vsYesterday': 'vs Yesterday',
  'crm.dashboard.miningNow': 'Mining Now',
  'crm.dashboard.thisMonth': 'This Month',
  'crm.dashboard.refresh': 'Refresh',
  'crm.dashboard.loadFailed': 'Failed to load dashboard data',
  'crm.dashboard.noPendingWithdrawals': 'No pending withdrawals',
  // Platform Stats
  'crm.dashboard.platformOverview': 'Platform Overview',
  'crm.dashboard.totalRevenue': 'Total Revenue',
  'crm.dashboard.totalWithdrawn': 'Total Withdrawn',
  'crm.dashboard.platformBtcBalance': 'Platform BTC Balance',
  'crm.dashboard.platformBtcBalanceDesc': 'Sum of all user BTC balances',
  'crm.dashboard.totalHashrate': 'Total Hashrate',
  'crm.dashboard.todayBtcOutput': 'Today BTC Output',
  'crm.dashboard.wau': 'WAU',
  'crm.dashboard.wauDesc': 'Users with mining activity in last 7 days',
  'crm.dashboard.arpu': 'ARPU',
  'crm.dashboard.arpuDesc': 'Average Revenue Per User (Revenue / Paid Users)',
  'crm.dashboard.minersExpiringSoon': 'Miners Expiring Soon',
  'crm.dashboard.minersExpiringSoonDesc': 'Miners expiring within 7 days',
  'crm.dashboard.referralRate': 'Referral Rate',
  'crm.dashboard.referralRateDesc': 'Users registered via referral code',
  'crm.dashboard.userActivity': 'User Overview',
  'crm.dashboard.miningHealth': 'Mining Health',
  'crm.dashboard.financeTitle': 'Financial Overview',
  'crm.dashboard.retentionRate': 'Retention Rate',
  'crm.dashboard.retentionRateDesc': 'Active on day N after registration',
  'crm.dashboard.paymentRateTitle': 'Payment Rate',
  'crm.dashboard.paymentRateDesc': 'First paid within N days of registration',
  'crm.dashboard.noData': 'No data',
  'crm.dashboard.cohortDate': 'Date',
  'crm.dashboard.cohortRegistrations': 'Registrations',
  'crm.dashboard.cohortDayLabel': 'D{days}',

  // Analytics (Cohort Analysis)
  'crm.analytics.title': 'Data Analytics',
  'crm.analytics.retentionRate': 'Retention Rate',
  'crm.analytics.retentionRateDesc': 'Active on day N after registration',
  'crm.analytics.paymentRate': 'Payment Rate',
  'crm.analytics.paymentRateDesc': 'First paid within N days of registration',
  'crm.analytics.roi': 'ROI Analysis',
  'crm.analytics.roiDesc':
    'ROI = Revenue / Cost (≥1 means break-even). Revenue is from completed orders within N days of registration.',
  'crm.analytics.cost': 'Cost',
  'crm.analytics.costPerUser': 'Cost per User',
  'crm.analytics.defaultCost': 'Default Cost',
  'crm.analytics.costUpdated': 'Cost updated',
  'crm.analytics.noData': 'No data',
  'crm.analytics.loadFailed': 'Failed to load analytics data',
  'crm.analytics.date': 'Date',
  'crm.analytics.registrations': 'Registrations',
  'crm.analytics.dayLabel': 'D{days}',

  // Channels
  'crm.channels.title': 'Channel Statistics',
  'crm.channels.overview': 'Channel Overview',
  'crm.channels.trend': 'Registration Trend (Last 30 Days)',
  'crm.channels.channel': 'Channel',
  'crm.channels.visits': 'Visits',
  'crm.channels.totalVisits': 'Total Visits',
  'crm.channels.todayVisits': 'Today Visits',
  'crm.channels.totalUsers': 'Total Users',
  'crm.channels.todayUsers': 'Today',
  'crm.channels.last7dUsers': 'Last 7d',
  'crm.channels.last30dUsers': 'Last 30d',
  'crm.channels.paidUsers': 'Paid Users',
  'crm.channels.paidRate': 'Paid Rate',
  'crm.channels.totalRevenue': 'Revenue (USDT)',
  'crm.channels.arpu': 'ARPU',
  'crm.channels.direct': 'Direct',
  'crm.channels.loadFailed': 'Failed to load channel data',
  'crm.channels.noData': 'No data',
  'crm.channels.totalChannels': 'Channels',
  'crm.channels.totalRegistrations': 'Total Registrations',
  'crm.channels.totalPaidUsers': 'Total Paid Users',
  'crm.channels.overallPaidRate': 'Overall Paid Rate',

  // Users
  'crm.users.title': 'User Management',
  'crm.users.list': 'User List',
  // Legacy user Excel import
  'crm.users.import.entry': 'Import Users',
  'crm.users.import.title': 'Import legacy users from Excel',
  'crm.users.import.helpTitle': 'How it works',
  'crm.users.import.helpDesc':
    'Each row creates an account registered as Google sign-in (no password) plus the new-user gift miner per System Settings. BTC balance is migrated directly. No mining session or transaction record is created. Required headers: email, btcBalance. Optional: registeredAt (writes user.createdAt; current time if empty).',
  'crm.users.import.registeredAt': 'Registered at',
  'crm.users.import.dragText': 'Click or drag an Excel file here (.xlsx / .xls)',
  'crm.users.import.dragHint':
    'Up to 2000 rows per upload. The file is parsed in the browser and previewed before submission.',
  'crm.users.import.downloadTemplate': 'Download template',
  'crm.users.import.parsedCount': 'Parsed {count} rows',
  'crm.users.import.parseErrors': '{count} rows with parse errors',
  'crm.users.import.missingHeaders': 'Missing required columns: {fields}',
  'crm.users.import.noRows': 'No rows to submit',
  'crm.users.import.submitBtn': 'Import {count} rows',
  'crm.users.import.summary':
    'Done: {success} created / {skipped} skipped / {failed} failed',
  'crm.users.import.resultTitle':
    'Total {total}, success {success}, skipped {skipped}, failed {failed}',
  'crm.users.detail': 'User Detail',
  'crm.users.dragToResize': 'Drag to resize',
  'crm.users.uid': 'UID',
  'crm.users.nickname': 'Nickname',
  'crm.users.email': 'Email',
  'crm.users.authMethod': 'Auth Method',
  'crm.users.status': 'Status',
  'crm.users.isPaid': 'Paid Status',
  'crm.users.paid': 'Paid',
  'crm.users.free': 'Free',
  'crm.users.balance': 'Balance',
  'crm.users.btcBalance': 'BTC Balance',
  'crm.users.bldBalance': 'BLD Balance',
  'crm.users.referrals': 'Referrals',
  'crm.users.commission': 'Commission',
  'crm.users.registeredAt': 'Registered At',
  'crm.users.registeredAtRange': 'Registered Range',
  'crm.users.searchReferredByUid': 'Inviter UID',
  'crm.users.searchReferredByCode': 'Inviter Code',
  'crm.users.active': 'Active',
  'crm.users.inactive': 'Inactive',
  'crm.users.disabled': 'Disabled',
  'crm.users.banned': 'Banned',
  'crm.users.adjustBalance': 'Adjust Balance',
  'crm.users.adjustBalanceTitle': 'Adjust User Balance',
  'crm.users.adjustAmount': 'Adjust Amount',
  'crm.users.adjustAmountHint': 'Positive to add, negative to deduct',
  'crm.users.adjustReason': 'Reason',
  'crm.users.basicInfo': 'Basic Information',
  'crm.users.acceptCommission': 'Accept Commission',
  'crm.users.acceptCommissionDesc':
    'When disabled, this user will be skipped as a referrer and will not receive commission from downstream users (the chain continues to their upline).',
  'crm.users.upwardCommission': 'Pay Upward Commission',
  'crm.users.upwardCommissionDesc':
    'When disabled, no referral commission will be paid to any upline when this user purchases goods or claims mining rewards (entire chain is cut).',
  'crm.users.referralFlagUpdated': 'Referral flag updated',
  'crm.users.referralFlagUpdateFailed': 'Failed to update referral flag',
  'crm.users.referralStats': 'Referral Statistics',
  'crm.users.totalReferrals': 'Total Referrals',
  'crm.users.level1Referrals': 'Level 1',
  'crm.users.level2Referrals': 'Level 2',
  'crm.users.level3Referrals': 'Level 3',
  'crm.users.totalCommission': 'Total Commission',
  'crm.users.transactions': 'Transactions',
  'crm.users.miners': 'Miners',
  'crm.users.mining': 'Mining',
  'crm.users.miningCurrent': 'Current Status',
  'crm.users.miningStatusOn': 'Mining',
  'crm.users.miningStatusOff': 'Idle',
  'crm.users.miningClaimable': 'Pending Claim',
  'crm.users.miningTotalClaimed': 'Total Claimed',
  'crm.users.miningClaimedCount': 'Claimed Sessions',
  'crm.users.miningTotalSessions': 'Total Sessions',
  'crm.users.miningStatus': 'Status',
  'crm.users.miningStatusMining': 'Mining',
  'crm.users.miningStatusClaimable': 'Claimable',
  'crm.users.miningStatusClaimed': 'Claimed',
  'crm.users.miningStatusCancelled': 'Cancelled',
  'crm.users.miningStartTime': 'Start',
  'crm.users.miningEndTime': 'End',
  'crm.users.miningHashrate': 'Hashrate',
  'crm.users.miningMinersCount': 'Miners',
  'crm.users.miningEstimatedYield': 'Estimated Yield',
  'crm.users.miningAccumulatedYield': 'Accumulated Yield',
  'crm.users.miningActualYield': 'Actual Yield',
  'crm.users.miningClaimedAt': 'Claimed At',
  'crm.users.viewUser': 'View User',
  'crm.users.referralCode': 'Referral Code',
  'crm.users.referredBy': 'Referred By',
  'crm.users.lastLogin': 'Last Login',
  'crm.users.totalEarnings': 'Total Earnings',
  'crm.users.level1Users': 'Level 1 Users',
  'crm.users.level1Commission': 'Level 1 Commission',
  'crm.users.level2Users': 'Level 2 Users',
  'crm.users.level2Commission': 'Level 2 Commission',
  'crm.users.level3Users': 'Level 3 Users',
  'crm.users.level3Commission': 'Level 3 Commission',
  'crm.users.loadFailed': 'Failed to load user detail',
  'crm.users.adjustSuccess': 'Balance adjusted successfully',
  'crm.users.adjustReasonPlaceholder': 'Enter the reason for adjustment',
  'crm.users.totalDeposit': 'Total Deposit',
  'crm.users.totalWithdrawBTC': 'Total Withdraw BTC',
  'crm.users.totalWithdrawUSDT': 'Total Withdraw USDT',
  'crm.users.totalWithdrawFee': 'Withdraw Fee (BTC)',
  'crm.users.depositWithdrawStats': 'Deposit & Withdraw Statistics',
  'crm.users.fissionCount': 'Fission Count',
  'crm.users.hashrate': 'Hashrate',
  'crm.users.country': 'Country',
  'crm.users.channel': 'Channel',
  'crm.users.lastLoginIp': 'Last Login IP',
  'crm.users.btcBalanceChanges': 'BTC Balance Changes',
  'crm.users.directReferrals': 'Direct Referrals',
  'crm.users.fissionUsers': 'Fission Users',
  'crm.users.fissionLevel': 'Level',
  'crm.users.levelN': 'L{n}',

  // Miners
  'crm.miners.title': 'Miner Management',
  'crm.miners.products': 'Miner Products',
  'crm.miners.addProduct': 'Add Product',
  'crm.miners.editProduct': 'Edit Product',
  'crm.miners.addMinerProduct': 'Add Miner Product',
  'crm.miners.editMinerProduct': 'Edit Miner Product',
  'crm.miners.model': 'Model',
  'crm.miners.type': 'Type',
  'crm.miners.typeStandard': 'Standard',
  'crm.miners.typeNewUser': 'New User',
  'crm.miners.hashrate': 'Hashrate',
  'crm.miners.hashrateUnit': 'Hashrate (TH/s)',
  'crm.miners.price': 'Price',
  'crm.miners.priceUSD': 'Price (USD)',
  'crm.miners.priceBTC': 'Price (BTC)',
  'crm.miners.cryptoDiscount': 'Crypto Discount',
  'crm.miners.cryptoDiscountTip':
    'Multiplier applied when paying with crypto (0~1, 1 = no discount). e.g. 0.95 → 5% off, a $10 product only costs $9.5 via crypto. Card / Google Play still use the original price.',
  'crm.miners.dailyOutput': 'Daily Output',
  'crm.miners.dailyOutputBTC': 'Daily Output (BTC)',
  'crm.miners.validDays': 'Valid Days',
  'crm.miners.yieldDailyBtc': 'Daily yield',
  'crm.miners.yieldHalfValidDaysBtc': 'Half-period yield',
  'crm.miners.yieldFullValidDaysBtc': 'Full-period yield',
  'crm.miners.yieldBtcHint':
    'Estimated BTC using Mining settings (base output per TH per hour × 24 h). Updates as hashrate and valid days change.',
  'crm.miners.yieldBtcLoading': 'Loading base mining rate…',
  'crm.miners.yieldBtcLoadFailed':
    'Could not load base mining rate. Check system settings permission or try again later.',
  'crm.miners.yieldBtcPriceNote':
    'Reference BTC price: ≈ {price} USDT per 1 BTC',
  'crm.miners.yieldApproxUsdt': '(≈ {amount} USDT)',
  'crm.miners.days': 'days',
  'crm.miners.available': 'Available',
  'crm.miners.unavailable': 'Unavailable',
  'crm.miners.image': 'Image',
  'crm.miners.description': 'Description',
  'crm.miners.totalProducts': 'Total Products',
  'crm.miners.totalHashrate': 'Total Hashrate',
  'crm.miners.expires': 'Expires',
  'crm.miners.purchased': 'Purchased',
  'crm.miners.remark': 'Remark',
  'crm.miners.manufacturer': 'Manufacturer',
  'crm.miners.inventory': 'Inventory',
  'crm.miners.sortOrder': 'Sort Order',
  'crm.miners.sortOrderTip':
    'List display weight. The larger the value, the higher it appears in the App and CRM lists. Items with the same weight are sorted by price ascending.',
  'crm.miners.tags': 'Tags',
  'crm.miners.algorithm': 'Algorithm',
  'crm.miners.powerConsumption': 'Power Consumption (W)',
  'crm.miners.deleteConfirm': 'Are you sure to delete this product?',
  'crm.miners.createSuccess': 'Product created successfully',
  'crm.miners.updateSuccess': 'Product updated successfully',
  'crm.miners.deleteSuccess': 'Product deleted successfully',
  'crm.miners.enableSuccess': 'Product enabled successfully',
  'crm.miners.disableSuccess': 'Product disabled successfully',
  'crm.miners.syncBagelPay': 'Configure BagelPay',
  'crm.miners.bagelPaySyncing': 'Syncing to BagelPay...',
  'crm.miners.bagelPaySyncSuccess': 'BagelPay product configured successfully',
  'crm.miners.bagelPaySyncFailed': 'BagelPay product configuration failed',
  'crm.miners.tagHot': 'HOT SALE',
  'crm.miners.tagBestValue': 'BEST VALUE',
  'crm.miners.tagEntry': 'ENTRY LEVEL',
  'crm.miners.tagNew': 'NEW',
  'crm.miners.tagHighYield': 'HIGH YIELD',
  'crm.miners.tagFreeTrial': 'FREE TRIAL',
  'crm.miners.uploadImage': 'Upload Image',
  'crm.miners.uploadImageTip': 'Click or drag to upload product image',
  'crm.miners.uploadSuccess': 'Image uploaded successfully',
  'crm.miners.uploadFailed': 'Image upload failed',
  'crm.miners.addInventory': 'Add Inventory',
  'crm.miners.addInventoryTitle': 'Add Product Inventory',
  'crm.miners.addInventoryAmount': 'Add Amount',
  'crm.miners.addInventorySuccess': 'Inventory added successfully',
  'crm.miners.addInventoryFailed': 'Add inventory failed',
  'crm.miners.reduceInventory': 'Reduce Inventory',
  'crm.miners.reduceInventoryTitle': 'Reduce Product Inventory',
  'crm.miners.reduceInventoryAmount': 'Reduce Amount',
  'crm.miners.reduceInventorySuccess': 'Inventory reduced successfully',
  'crm.miners.reduceInventoryFailed': 'Reduce inventory failed',
  'crm.miners.currentInventory': 'Current Inventory',
  'crm.miners.grantMiner': 'Grant Miner',
  'crm.miners.grantMinerTitle': 'Grant Miner to User',
  'crm.miners.grantMinerSelect': 'Select Miner Product',
  'crm.miners.grantMinerConfirm':
    'Are you sure to grant this miner to the user?',
  'crm.miners.grantMinerSuccess': 'Miner granted successfully',
  'crm.miners.grantMinerFailed': 'Grant miner failed',
  'crm.miners.grantOrderMiner': 'Send order miner',
  'crm.miners.grantOrderMinerTitle': 'Send order miner (paid order)',
  'crm.miners.grantOrderMinerSuccess': 'Order miner created. Order ID: {orderId}',
  'crm.miners.grantOrderMinerFailed': 'Failed to create order miner',
  'crm.miners.grantOrderPurchasedAt': 'Miner purchase time',
  'crm.miners.grantOrderMinerStart': 'Miner start time',
  'crm.miners.grantOrderMinerEnd': 'Miner end time',
  'crm.miners.grantOrderMinerEndHint': 'Defaults to start time + product valid days; you may adjust manually',
  'crm.miners.grantOrderPaymentMethod': 'Order payment method',
  'crm.miners.grantOrderPayAmount': 'Order amount (USDT)',
  'crm.miners.grantOrderPayAmountHint':
    'Leave empty to use product price × quantity; can override manually.',
  'crm.miners.paymentCrypto': 'Crypto (NOWPayments)',
  'crm.miners.paymentCard': 'Card (BagelPay)',
  'crm.miners.paymentGooglePay': 'Google Play',

  // Withdrawals
  'crm.withdrawals.title': 'Withdrawal Management',
  'crm.withdrawals.pending': 'Pending Withdrawals',
  'crm.withdrawals.history': 'Withdrawal History',
  'crm.withdrawals.id': 'ID',
  'crm.withdrawals.user': 'User',
  'crm.withdrawals.currency': 'Currency',
  'crm.withdrawals.network': 'Network',
  'crm.withdrawals.address': 'Address',
  'crm.withdrawals.amount': 'Amount',
  'crm.withdrawals.fee': 'Fee',
  'crm.withdrawals.receiveAmount': 'Receive Amount',
  'crm.withdrawals.status': 'Status',
  'crm.withdrawals.statusPending': 'Pending',
  'crm.withdrawals.statusApproved': 'Approved',
  'crm.withdrawals.statusProcessing': 'Processing',
  'crm.withdrawals.statusCompleted': 'Completed',
  'crm.withdrawals.statusRejected': 'Rejected',
  'crm.withdrawals.txHash': 'TX Hash',
  'crm.withdrawals.rejectReason': 'Reject Reason',
  'crm.withdrawals.processedAt': 'Processed At',
  'crm.withdrawals.processedBy': 'Processed By',
  'crm.withdrawals.approve': 'Approve',
  'crm.withdrawals.reject': 'Reject',
  'crm.withdrawals.batchApprove': 'Batch Approve',
  'crm.withdrawals.rejectTitle': 'Reject Withdrawal',
  'crm.withdrawals.rejectPlaceholder': 'Enter the reason for rejection',
  'crm.withdrawals.pendingRequests': 'Pending Requests',
  'crm.withdrawals.totalPendingAmount': 'Total Pending Amount',
  'crm.withdrawals.btcPending': 'BTC Pending',
  'crm.withdrawals.usdtPending': 'USDT Pending',
  'crm.withdrawals.approveSuccess': 'Withdrawal approved successfully',
  'crm.withdrawals.approveFailed': 'Approve failed',
  'crm.withdrawals.batchApproveFailed': 'Batch approve failed',
  'crm.withdrawals.rejectSuccess': 'Withdrawal rejected',
  'crm.withdrawals.rejectFailed': 'Reject failed',
  'crm.withdrawals.approveConfirm':
    'Are you sure to approve this withdrawal request?',
  'crm.withdrawals.selectAtLeastOne': 'Please select at least one withdrawal',
  'crm.withdrawals.batchApproveConfirm':
    'Are you sure to approve {count} withdrawal requests?',
  'crm.withdrawals.batchApproveSuccess': '{count} withdrawals approved',
  // Manual transfer (operator fallback)
  'crm.withdrawals.manualTransfer': 'Manual Transfer',
  'crm.withdrawals.manualTransferTitle': 'Complete via Manual Transfer',
  'crm.withdrawals.manualTransferConfirm': 'Confirm Manual Completion',
  'crm.withdrawals.manualTransferSuccess': 'Marked as manually completed',
  'crm.withdrawals.manualTransferFailed': 'Manual transfer failed',
  'crm.withdrawals.manualTransferWarningTitle':
    'Make sure the on-chain transfer is actually done',
  'crm.withdrawals.manualTransferWarningDesc':
    "This will mark the withdrawal as COMPLETED with the txHash you provide. Chain-scan will NOT be invoked, and the user's balance is NOT touched (already deducted at creation). Use ONLY after you have manually performed the on-chain transfer through an operator wallet.",
  'crm.withdrawals.manualTransferTxHash': 'Transaction Hash (TxHash)',
  'crm.withdrawals.manualTransferTxHashRequired':
    'Please enter the on-chain transaction hash',
  'crm.withdrawals.manualTransferTxHashExtra':
    'Enter the real on-chain txHash after you have manually completed the transfer, for user visibility and reconciliation.',
  'crm.withdrawals.manualTransferNote': 'Note (optional)',
  'crm.withdrawals.manualTransferNotePlaceholder':
    'Optional context, e.g. "chain-scan unavailable, paid from operator wallet".',

  // Activities
  'crm.activities.title': 'Activity Management',
  'crm.activities.dailyPool': 'Daily Pool',
  'crm.activities.social': 'Social Events',
  'crm.activities.periodDate': 'Period Date',
  'crm.activities.periodNumber': 'Period #',
  'crm.activities.reward': 'Reward',
  'crm.activities.totalParticipants': 'Total Participants',
  'crm.activities.qualifiedParticipants': 'Qualified',
  'crm.activities.totalInvites': 'Total Invites',
  'crm.activities.perUserReward': 'Per User Reward',
  'crm.activities.statusActive': 'Active',
  'crm.activities.statusSettled': 'Settled',
  'crm.activities.statusUpcoming': 'Upcoming',
  'crm.activities.statusEnded': 'Ended',
  'crm.activities.settledAt': 'Settled At',
  'crm.activities.settings': 'Settings',
  'crm.activities.defaultReward': 'Default Reward',
  'crm.activities.minInvitesToQualify': 'Min Invites to Qualify',
  'crm.activities.todayPool': "Today's Pool",
  'crm.activities.todayParticipants': "Today's Participants",
  'crm.activities.todayQualified': "Today's Qualified",
  'crm.activities.totalDistributed': 'Total Distributed',
  'crm.activities.todayProgress': "Today's Progress",
  'crm.activities.qualifiedRate': 'Qualified Rate',
  'crm.activities.avgInvitesPerUser': 'Avg Invites/User',
  'crm.activities.estPerUser': 'Est. Per User',
  'crm.activities.participants': 'Participants',
  'crm.activities.invites': 'Invites',
  'crm.activities.qualified': 'Qualified',
  'crm.activities.joinedAt': 'Joined At',
  // Social Events
  'crm.activities.twitter': 'Twitter Challenge',
  'crm.activities.youtube': 'YouTube Creator',
  'crm.activities.createPeriod': 'Create Period',
  'crm.activities.eventType': 'Event Type',
  'crm.activities.duration': 'Duration',
  'crm.activities.startTime': 'Start Time',
  'crm.activities.endTime': 'End Time',
  'crm.activities.submissions': 'Submissions',
  'crm.activities.approved': 'Approved',
  'crm.activities.pending': 'Pending',
  'crm.activities.pendingReview': 'Pending Review',
  'crm.activities.rejected': 'Rejected',
  'crm.activities.totalSubmissions': 'Total Submissions',
  'crm.activities.link': 'Link',
  'crm.activities.submittedAt': 'Submitted At',
  'crm.activities.reviewedAt': 'Reviewed At',
  'crm.activities.viewLink': 'View Link',
  'crm.activities.rejectSubmission': 'Reject Submission',
  'crm.activities.activePeriodReward': 'Active Period Reward',
  'crm.activities.activeSubmissions': 'Active Submissions',
  'crm.activities.totalPeriods': 'Total Periods',
  'crm.activities.rewardAmountBTC': 'Reward Amount (BTC)',
  'crm.activities.approve': 'Approve',
  'crm.activities.reject': 'Reject',
  'crm.activities.approveSubmission': 'Approve Submission',
  'crm.activities.approveSubmissionConfirm':
    'Are you sure to approve this submission?',
  'crm.activities.approveSuccess': 'Submission approved',
  'crm.activities.rejectReason': 'Reject Reason',
  'crm.activities.rejectReasonRequired': 'Please enter rejection reason',
  'crm.activities.rejectReasonPlaceholder': 'Enter rejection reason',
  'crm.activities.rejectSuccess': 'Submission rejected',
  'crm.activities.selectSubmissions': 'Please select submissions',
  'crm.activities.batchApprove': 'Batch Approve',
  'crm.activities.batchApproveConfirm':
    'Are you sure to approve {count} submissions?',
  'crm.activities.batchApproveSuccess': '{count} submissions approved',
  'crm.activities.periodInfo': 'Period Information',
  'crm.activities.rewardPool': 'Reward Pool',
  'crm.activities.dailyPoolHistory': 'Daily Pool History',
  'crm.activities.dailyPoolSettings': 'Daily Pool Settings',
  'crm.activities.dailyPoolDetail': 'Daily Pool Detail',
  'crm.activities.qualifiedUsers': 'Qualified Users',
  'crm.activities.statusPending': 'Pending',
  'crm.activities.statusDistributed': 'Distributed',
  'crm.activities.distributedAmount': 'Distributed Amount',
  'crm.activities.distributedAt': 'Distributed At',
  'crm.activities.distribute': 'Distribute',
  'crm.activities.distributeReward': 'Distribute Reward',
  'crm.activities.distributeSettings': 'Distribution Settings',
  'crm.activities.distributeAmount': 'Distribution Amount',
  'crm.activities.distributeCurrency': 'Distribution Currency',
  'crm.activities.confirmDistribute': 'Confirm Distribution',
  'crm.activities.distributeSuccess': 'Reward distributed successfully',
  'crm.activities.rewardPreview': 'Reward Preview',
  'crm.activities.share': 'Share',
  'crm.activities.pendingDistribute': 'Pending Distribution',
  'crm.activities.todayInvites': "Today's Invites",
  'crm.activities.skipped': 'Skipped',
  'crm.activities.skipTip': 'Check to skip distribution',
  'crm.activities.skippedCount': '{count} skipped',
  'crm.activities.fissionCount': 'Fission Count',
  'crm.activities.linkType': 'Link Type',
  'crm.activities.approvedUsers': 'Approved Users',
  'crm.activities.distributeAmountRequired': 'Please enter distribute amount',
  'crm.activities.socialEvents': 'Social Events',
  'crm.activities.rewarded': 'Rewarded',
  'crm.activities.totalRewarded': 'Total Rewarded',
  'crm.activities.totalRewardAmount': 'Total Reward Amount',
  'crm.activities.rewardStatus': 'Reward Status',
  'crm.activities.notRewarded': 'Not Rewarded',
  'crm.activities.sendReward': 'Send Reward',
  'crm.activities.confirmReward': 'Confirm Reward',
  'crm.activities.rewardAmount': 'Reward Amount',
  'crm.activities.rewardCurrency': 'Reward Currency',
  'crm.activities.rewardAmountRequired': 'Please enter reward amount',
  'crm.activities.rewardSuccess': 'Reward sent successfully',
  'crm.activities.submittedLink': 'Submitted Link',
  'crm.activities.copyLink': 'Copy Link',
  'crm.activities.linkCopied': 'Link copied',
  'crm.activities.amountPositive': 'Amount must be positive',
  'crm.activities.distributeFailed': 'Distribute failed',
  'crm.activities.configUpdated': 'Config updated',
  'crm.activities.updateFailed': 'Update failed',
  'crm.activities.rewardFailed': 'Reward failed',
  'crm.activities.createFailed': 'Create failed',

  // Transactions
  'crm.transactions.title': 'Transaction Records',
  'crm.transactions.type': 'Type',
  'crm.transactions.typeDeposit': 'Deposit',
  'crm.transactions.typeWithdraw': 'Withdraw',
  'crm.transactions.typePurchase': 'Purchase',
  'crm.transactions.typeClaim': 'Claim',
  'crm.transactions.typeReferral': 'Referral',
  'crm.transactions.typeSwap': 'Swap',
  'crm.transactions.typeEvent': 'Event',
  'crm.transactions.typePlatformReward': 'Platform Reward',
  'crm.transactions.amount': 'Amount',
  'crm.transactions.description': 'Description',
  'crm.transactions.statusPending': 'Pending',
  'crm.transactions.statusCompleted': 'Completed',
  'crm.transactions.statusFailed': 'Failed',
  'crm.transactions.time': 'Time',
  'crm.transactions.todayTransactions': "Today's Transactions",
  'crm.transactions.todayVolume': "Today's Volume",
  'crm.transactions.todayIncome': "Today's Income",
  'crm.transactions.totalTransactions': 'Total Transactions',
  'crm.transactions.allTransactions': 'All Transactions',
  'crm.transactions.user': 'User',
  'crm.transactions.status': 'Status',
  'crm.transactions.actions': 'Actions',
  'crm.transactions.viewUser': 'View User',
  'crm.transactions.loadFailed': 'Failed to load transactions',
  'crm.transactions.loadUserFailed': 'Failed to load user detail',

  // Orders
  'crm.orders.title': 'Order Management',
  'crm.orders.list': 'Order List',
  'crm.orders.orderId': 'Order ID',
  'crm.orders.userId': 'User ID',
  'crm.orders.email': 'Email',
  'crm.orders.type': 'Type',
  'crm.orders.typeMiner': 'Miner',
  'crm.orders.typeLottery': 'Lottery',
  'crm.orders.speed': 'Speed',
  'crm.orders.payAmount': 'Payment Amount',
  'crm.orders.status': 'Order Status',
  'crm.orders.statusPending': 'Pending Payment',
  'crm.orders.statusPaid': 'Paid',
  'crm.orders.statusCancelled': 'Cancelled',
  'crm.orders.statusExpired': 'Expired',
  'crm.orders.isFirstOrder': 'First Order',
  'crm.orders.isFirst': 'Yes',
  'crm.orders.notFirst': 'No',
  'crm.orders.isPromoOrder': 'Promotion',
  'crm.orders.promoTag': 'Promo',
  'crm.orders.originalPrice': 'Original Price',
  'crm.orders.discountPercent': 'Discount',
  'crm.orders.createdAt': 'Order Time',
  'crm.orders.createdAtRange': 'Created Time',
  'crm.orders.orderIdSearchPlaceholder': 'Order ID / Google Order ID (GPA.xxx)',
  'crm.orders.expiredAt': 'Expiry Time',
  'crm.orders.totalOrders': 'Total Orders',
  'crm.orders.pendingOrders': 'Pending Orders',
  'crm.orders.paidOrders': 'Paid Orders',
  'crm.orders.expiredOrders': 'Expired Orders',
  'crm.orders.todayOrders': "Today's Orders",
  'crm.orders.todayPaid': "Today's Paid",
  'crm.orders.totalAmount': 'Total Amount',
  'crm.orders.expirationTime': 'Expiry (1 hour unpaid)',
  'crm.orders.productName': 'Product Name',
  'crm.orders.quantity': 'Quantity',
  'crm.orders.detail': 'Order Detail',
  'crm.orders.payCurrency': 'Pay Currency',
  'crm.orders.payAmountCrypto': 'Crypto Amount',
  'crm.orders.paymentMethod': 'Payment Method',
  'crm.orders.payAddress': 'Pay Address',
  'crm.orders.network': 'Network',
  'crm.orders.nowPaymentId': 'NOWPayments ID',
  'crm.orders.paidAt': 'Paid At',
  'crm.orders.orderInfo': 'Order Info',
  'crm.orders.paymentInfo': 'Payment Info',
  'crm.orders.completeAction': 'Complete Order',
  'crm.orders.completeTitle': 'Manually Complete Order',
  'crm.orders.completeConfirm': 'Confirm',
  'crm.orders.completeTip':
    'Use this when the user has actually paid but the IPN callback never arrived. Make sure payment has been received before proceeding.',
  'crm.orders.completeSuccess': 'Order completed',
  'crm.orders.completeFailed': 'Failed to complete order',
  'crm.orders.grantMiner': 'Also grant miner(s)',
  'crm.orders.grantMinerOnDesc':
    'Run the full purchase flow: decrement inventory, create miners and bind them to the farm, accumulate hashrate, and distribute referral commission.',
  'crm.orders.grantMinerOffDesc':
    'Skip miner generation (use this if miners were already granted manually). The order will be marked as paid and a transaction record will be written, but no inventory change, no new miners, and no referral commission.',

  // Tickets
  'crm.tickets.title': 'Ticket Management',
  'crm.tickets.products': 'Ticket Products',
  'crm.tickets.addProduct': 'Add Ticket Package',
  'crm.tickets.editProduct': 'Edit Ticket Package',
  'crm.tickets.name': 'Package Name',
  'crm.tickets.ticketAmount': 'Ticket Amount',
  'crm.tickets.bonusAmount': 'Bonus Amount',
  'crm.tickets.totalAmount': 'Total Amount',
  'crm.tickets.price': 'Price (USDT)',
  'crm.tickets.originalPrice': 'Original Price (USDT)',
  'crm.tickets.tag': 'Tag',
  'crm.tickets.sortOrder': 'Sort Order',
  'crm.tickets.available': 'Available',
  'crm.tickets.unavailable': 'Unavailable',
  'crm.tickets.deleteConfirm': 'Are you sure to delete this ticket package?',
  'crm.tickets.createSuccess': 'Ticket package created successfully',
  'crm.tickets.updateSuccess': 'Ticket package updated successfully',
  'crm.tickets.deleteSuccess': 'Ticket package deleted successfully',
  'crm.tickets.enableSuccess': 'Ticket package enabled',
  'crm.tickets.disableSuccess': 'Ticket package disabled',
  'crm.tickets.namePlaceholder': 'e.g. Basic, Premium',
  'crm.tickets.tagPlaceholder': 'e.g. +5 Bonus, HOT',

  // Messages
  'crm.messages.title': 'Message Management',
  'crm.messages.list': 'Message List',
  'crm.messages.send': 'Send Message',
  'crm.messages.type': 'Message Type',
  'crm.messages.typeSystem': 'System',
  'crm.messages.typeActivity': 'Activity',
  'crm.messages.typePersonal': 'Personal',
  'crm.messages.messageTitle': 'Title',
  'crm.messages.messageContent': 'Content',
  'crm.messages.sendTarget': 'Send Target',
  'crm.messages.allUsers': 'All Users (Broadcast)',
  'crm.messages.specifiedUser': 'Specified User',
  'crm.messages.paidUsers': 'Paid Users',
  'crm.messages.withdrawnUsers': 'Withdrawn Users',
  'crm.messages.activeUsers': 'Active Users (N Days)',
  'crm.messages.activeDays': 'Active Days',
  'crm.messages.activeDaysPlaceholder':
    'Enter days (e.g. 7 for users active in last 7 days)',
  'crm.messages.activeDaysRequired': 'Please enter active days',
  'crm.messages.targetUser': 'Target User',
  'crm.messages.searchUser': 'Search by nickname, UID or email',
  'crm.messages.sentBy': 'Sent By',
  'crm.messages.sendTime': 'Send Time',
  'crm.messages.deleteConfirm': 'Confirm Delete',
  'crm.messages.deleteConfirmContent':
    'This action cannot be undone. Are you sure to delete this message?',
  'crm.messages.deleteSuccess': 'Message deleted',
  'crm.messages.deleteFailed': 'Delete failed',
  'crm.messages.sendSuccess': 'Message sent with push notification',
  'crm.messages.sendFailed': 'Send failed',
  'crm.messages.titleRequired': 'Please enter a title',
  'crm.messages.titleMaxLength': 'Title cannot exceed 200 characters',
  'crm.messages.contentRequired': 'Please enter content',
  'crm.messages.contentMaxLength': 'Content cannot exceed 10000 characters',
  'crm.messages.selectUser': 'Please select a target user',
  'crm.messages.selectType': 'Please select message type',
  'crm.messages.titlePlaceholder': 'Message title',
  'crm.messages.contentPlaceholder': 'Message content',
  'crm.messages.sendButton': 'Send',
  'crm.messages.noMessages': 'No messages',

  // Wallet Connections
  'crm.wallets.title': 'Wallet Connections',
  'crm.wallets.address': 'Wallet Address',
  'crm.wallets.chain': 'Chain',
  'crm.wallets.connectedAt': 'Connected At',
  'crm.wallets.lastActive': 'Last Active',
  'crm.wallets.connected': 'Connected',
  'crm.wallets.disconnected': 'Disconnected',
  'crm.users.wallets': 'Wallet Connections',

  // Click Statistics
  'crm.clickStats.title': 'Click Statistics',
  'crm.clickStats.totalClicks': 'Total Clicks',
  'crm.clickStats.convertedClicks': 'Converted',
  'crm.clickStats.conversionRate': 'Conversion Rate',
  'crm.clickStats.recentClicks': 'Recent Clicks',
  'crm.clickStats.days': 'days',
  'crm.clickStats.uniqueUsers': 'Unique Users',
  'crm.clickStats.dailyTrend': 'Daily Trend',

  // Settings
  'crm.settings.title': 'System Settings',
  'crm.settings.mining': 'Mining',
  'crm.settings.referral': 'Referral',
  'crm.settings.dailyPool': 'Daily Pool',
  'crm.settings.socialEvents': 'Social Events',
  'crm.settings.pwaReward': 'PWA Reward',
  'crm.settings.pwaRewardConfig': 'PWA Install Reward',
  'crm.settings.pwaRewardConfigDesc':
    'Reward users with BTC when they install the app as a PWA. The reward is granted automatically once when the user opens the installed PWA.',
  'crm.settings.enablePwaReward': 'Enable PWA Install Reward',
  'crm.settings.pwaRewardAmount': 'Reward Amount (BTC)',
  'crm.settings.pwaCutoffDate': 'Registration Cutoff Date',
  'crm.settings.pwaCutoffDateDesc':
    'Users registered before this date are not eligible for the PWA reward and will not see the PWA event on the activity page',
  'crm.settings.payment': 'Payment',
  'crm.settings.paymentEnabled': 'Enable NOWPayments',
  'crm.settings.refundClawbackEnabled': 'Clawback BTC on Refund',
  'crm.settings.refundClawbackEnabledTip':
    'When enabled, refunds claw back already-claimed mining earnings (balance may go negative and withdrawals are frozen). When disabled, refunds only stop the miners without clawing back earnings.',
  'crm.settings.paymentEnabledTip':
    'When disabled, the web frontend will show a "Payment channel upgrading" message and users cannot make purchases',
  'crm.settings.bagelPayEnabled': 'Enable BagelPay Card Payment',
  'crm.settings.bagelPayEnabledTip':
    'When enabled, a "Pay with Card" button will appear in the purchase modal on the web frontend',
  'crm.settings.currencyConfig': 'Currency Configuration',
  'crm.settings.currencyConfigDesc':
    'Configure available payment currencies and display order for the frontend. Leave the allowed list empty to show all currencies.',
  'crm.settings.allowedCurrencies': 'Allowed Currencies',
  'crm.settings.allCurrencies': 'All Currencies',
  'crm.settings.enabledCurrencies': 'Enabled',
  'crm.settings.allowedCurrenciesTip':
    'Empty (right side empty) = no restriction, show all available currencies',
  'crm.settings.pinnedCurrencies': 'Currency Display Order',
  'crm.settings.pinnedCurrenciesTip':
    'Use the arrows to adjust the display order of currencies on the frontend.',
  'crm.settings.system': 'System',
  'crm.settings.support': 'Support Contacts',
  'crm.settings.supportConfig': 'Support Contact Configuration',
  'crm.settings.supportConfigDesc':
    'Controls the contact options shown in the Contact Support dialog on the Vite frontend. Disabled or empty items are hidden.',
  'crm.settings.supportTelegram': 'Telegram',
  'crm.settings.supportEmail': 'Email',
  'crm.settings.supportWhatsapp': 'WhatsApp',
  'crm.settings.supportEnabled': 'Enabled',
  'crm.settings.supportTelegramUrl': 'Telegram URL',
  'crm.settings.supportEmailValue': 'Email Address',
  'crm.settings.supportWhatsappUrl': 'WhatsApp URL',
  'crm.settings.supportTelegramPaidUrl': 'Paid User Telegram URL',
  'crm.settings.supportEmailPaidValue': 'Paid User Email',
  'crm.settings.supportWhatsappPaidUrl': 'Paid User WhatsApp URL',
  'crm.settings.supportPaidUrlTip':
    'Paid users (those with a completed purchase) are redirected to this link. Leave empty to always use the default link.',
  'crm.settings.save': 'Save',
  'crm.settings.saveChanges': 'Save Changes',
  // Mining Settings
  'crm.settings.miningConfig': 'Mining Configuration',
  'crm.settings.sessionDuration': 'Session Duration (hours)',
  'crm.settings.baseRate': 'Base Rate per TH/hour',
  'crm.settings.withdrawalSettings': 'Withdrawal Settings',
  'crm.settings.minWithdrawBTC': 'Min Withdraw BTC',
  'crm.settings.minWithdrawBLD': 'Min Withdraw BLD',
  'crm.settings.withdrawFeeBTC': 'Withdraw Fee BTC',
  'crm.settings.withdrawFeeBLD': 'Withdraw Fee BLD',
  'crm.settings.dailyWithdrawalLimit': 'Daily withdrawals per user',
  'crm.settings.dailyWithdrawalLimitDesc':
    'Maximum number of withdrawal requests a single user may submit per UTC day. Counts pending, processing and completed records; admin-rejected withdrawals are NOT counted. Submissions beyond the limit are rejected on the App. Set to 0 to disable.',
  'crm.settings.withdrawNetworkOverrides': 'Per-network withdrawal overrides',
  'crm.settings.withdrawNetworkOverridesDesc':
    'Choose a withdrawal network and set optional minimum (BTC) and/or fee (BTC). Values here override the global fields above for that network only. App uses these when the user selects the corresponding network.',
  'crm.settings.withdrawNetworkSelect': 'Network',
  'crm.settings.withdrawNetworkOverrideMin': 'Min withdraw (BTC)',
  'crm.settings.withdrawNetworkOverrideFee': 'Fee (BTC)',
  'crm.settings.withdrawNetworkApply': 'Save for this network',
  'crm.settings.withdrawNetworkTableNetwork': 'Network',
  'crm.settings.withdrawNetworkTableMin': 'Min (BTC)',
  'crm.settings.withdrawNetworkTableFee': 'Fee (BTC)',
  'crm.settings.withdrawNetworkRemove': 'Remove',
  'crm.settings.withdrawNetworkPickNetwork': 'Please select a network',
  'crm.settings.withdrawNetworkNeedOneField': 'Enter at least min or fee to save an override',
  // Withdrawal Networks
  'crm.settings.withdrawalCurrencies': 'Withdrawal Currencies',
  'crm.settings.withdrawalCurrenciesDesc':
    'Controls which currencies App users can withdraw. Disabled currencies are hidden from the client and any incoming requests will be rejected.',
  'crm.settings.withdrawCurrencyBTCEnabled': 'Enable BTC withdrawal',
  'crm.settings.withdrawCurrencyUSDTEnabled': 'Enable USDT withdrawal',
  'crm.settings.withdrawalNetworks': 'Withdrawal Networks',
  'crm.settings.withdrawalNetworksDesc':
    'Select which networks are available for BTC and USDT withdrawals',
  'crm.settings.btcNetworks': 'BTC Withdrawal Networks',
  'crm.settings.usdtNetworks': 'USDT Withdrawal Networks',
  'crm.settings.btcNetworksRequired': 'Please select at least one BTC network',
  'crm.settings.usdtNetworksRequired':
    'Please select at least one USDT network',
  'crm.settings.selectNetworks': 'Select networks',
  // Referral Settings
  'crm.settings.referralConfig': 'Referral Configuration',
  'crm.settings.enableReferral': 'Enable Referral System',
  'crm.settings.enablePurchaseCommission': 'Purchase Commission',
  'crm.settings.enablePurchaseCommissionDesc':
    'When disabled, no referral commission will be paid to the inviter when users successfully pay for miners / farms / tickets.',
  'crm.settings.enableMiningClaimCommission': 'Mining Claim Commission',
  'crm.settings.enableMiningClaimCommissionDesc':
    'When disabled, no referral commission will be paid to the inviter when users claim their mining rewards.',
  'crm.settings.commissionRates': 'Commission Rates',
  'crm.settings.commissionDesc':
    'Commission rates for each referral level (percentage)',
  'crm.settings.level1Rate': 'Level 1 Rate (%)',
  'crm.settings.level2Rate': 'Level 2 Rate (%)',
  'crm.settings.level3Rate': 'Level 3 Rate (%)',
  'crm.settings.maxLevels': 'Max Referral Levels',
  // Share Text
  'crm.settings.shareTextTitle': 'Share Text',
  'crm.settings.shareTextDesc':
    'Text used when users share their referral link. Use {link} as placeholder for the referral link.',
  'crm.settings.shareText': 'Share Text',
  'crm.settings.shareTextPlaceholder':
    'e.g. Join CoreX-BTC and start mining BTC! Use my referral link: {link}',
  // Daily Pool Settings
  'crm.settings.dailyPoolConfig': 'Daily Pool Configuration',
  'crm.settings.enableDailyPool': 'Enable Daily Pool',
  'crm.settings.autoSettle': 'Auto Settle Rewards',
  'crm.settings.defaultReward': 'Default Reward (BTC)',
  'crm.settings.minInvites': 'Min Invites to Qualify',
  // Daily Pool Message Template
  'crm.settings.messageTemplateTitle': 'Push Message Template',
  'crm.settings.messageTemplateDesc':
    'In-app message sent to users when daily pool rewards are distributed. Use {amount} and {currency} as placeholders.',
  'crm.settings.messageTemplate': 'Message Template',
  'crm.settings.messageTemplatePlaceholder':
    'e.g. Congratulations! You earned {amount} {currency} from the Daily Pool reward. Keep inviting friends to earn more!',
  // Social Event Settings
  'crm.settings.socialEventConfig': 'Social Events Configuration',
  'crm.settings.enableTwitter': 'Enable Twitter Challenge',
  'crm.settings.enableYoutube': 'Enable YouTube Creator',
  'crm.settings.twitterReward': 'Reward per Period (BTC)',
  'crm.settings.youtubeReward': 'Reward per Period (BTC)',
  'crm.settings.periodDays': 'Period Duration (days)',
  // New User Settings
  'crm.settings.newUser': 'New User',
  'crm.settings.newUserConfig': 'New User Miner Configuration',
  'crm.settings.newUserConfigDesc':
    'Configure the miner that new users will receive automatically',
  'crm.settings.enableNewUserMiner': 'Enable New User Miner',
  'crm.settings.selectNewUserMiner': 'Select New User Miner',
  'crm.settings.selectNewUserMinerPlaceholder':
    'Please select a miner for new users',
  'crm.settings.selectNewUserMinerRequired': 'Please select a miner',
  'crm.settings.uploadText': 'Upload',
  'crm.settings.removeImage': 'Remove',
  'crm.settings.onlyImageAllowed': 'Only image files are allowed',
  'crm.settings.imageTooLarge': 'Image must be smaller than 5MB',
  'crm.settings.imageUploadSuccess': 'Image uploaded successfully',
  'crm.settings.imageUploadFailed': 'Upload failed',
  'crm.settings.loadFailed': 'Failed to load settings',
  'crm.settings.saveSuccess': '{section} settings saved',
  'crm.settings.saveFailed': 'Failed to save',
  'crm.settings.saveSettingsFailed': 'Failed to save settings',
  'crm.settings.cacheCleared': 'Cache cleared successfully',
  'crm.settings.cacheClearFailed': 'Failed to clear cache',
  // Social Event Settings
  'crm.settings.enableSocialEvents': 'Enable Social Events',
  // Social Event Message Template
  'crm.settings.socialMessageTemplateTitle': 'Push Message Template',
  'crm.settings.socialMessageTemplateDesc':
    'In-app message sent to users when social event rewards are distributed. Use {amount} and {currency} as placeholders.',
  'crm.settings.socialMessageTemplate': 'Message Template',
  'crm.settings.socialMessageTemplatePlaceholder':
    'e.g. Congratulations! You earned {amount} {currency} for your social media contribution. Keep creating great content!',
  // System Info
  'crm.settings.systemInfo': 'System Information',
  'crm.settings.environment': 'Environment',
  'crm.settings.version': 'Version',
  'crm.settings.apiStatus': 'API Status',
  'crm.settings.database': 'Database',
  'crm.settings.maintenance': 'Maintenance',
  'crm.settings.clearCache': 'Clear Cache',
  'crm.settings.reindexDb': 'Reindex Database',
  'crm.settings.resetEventPeriods': 'Reset Event Periods',
  'crm.settings.online': 'Online',
  'crm.settings.connected': 'Connected',
  'crm.settings.disconnected': 'Disconnected',

  // Payment Settings - BSC Wallet & Reconciliation
  'crm.settings.bscWalletAddress': 'BSC Wallet Address',
  'crm.settings.bscWalletAddressTip':
    'BEP-20 wallet address on BSC for receiving NOWPayments funds',
  'crm.settings.bscWalletAddressPlaceholder': '0x...',
  'crm.settings.autoReconciliation': 'Auto Reconciliation',
  'crm.settings.autoReconciliationTip':
    'Automatically check wallet balance every 10 minutes and disable payment if anomaly detected',
  'crm.settings.reconciliationInterval': 'Check Interval (min)',
  'crm.settings.reconciliationIntervalTip':
    'How often to run wallet reconciliation (in minutes, 1-1440)',
  'crm.settings.reconciliationThreshold': 'Anomaly Threshold (%)',
  'crm.settings.reconciliationThresholdTip':
    'Disable payment if wallet balance falls below this percentage of adjusted revenue',
  'crm.settings.consecutiveFailLimit': 'Consecutive Fail Limit',
  'crm.settings.consecutiveFailLimitTip':
    'Number of consecutive anomaly checks before auto-disabling payment',

  // Reconciliation Page
  'crm.reconciliation.title': 'Wallet Reconciliation',
  'crm.reconciliation.summary': 'Summary',
  'crm.reconciliation.logs': 'Reconciliation Logs',
  'crm.reconciliation.withdrawals': 'Withdrawals',
  'crm.reconciliation.notConfigured':
    'BSC wallet address not configured. Please set it in System Settings > Payment.',
  'crm.reconciliation.walletAddress': 'Wallet Address',
  'crm.reconciliation.bnbBalance': 'BNB Balance',
  'crm.reconciliation.usdtBalance': 'USDT Balance',
  'crm.reconciliation.walletTotal': 'Wallet Total (USDT)',
  'crm.reconciliation.bnbPrice': 'BNB Price',
  'crm.reconciliation.totalRevenue': 'Total Revenue',
  'crm.reconciliation.totalWithdrawn': 'Total Withdrawn',
  'crm.reconciliation.adjustedRevenue': 'Adjusted Revenue (×0.995)',
  'crm.reconciliation.consecutiveAnomalies': 'Consecutive Anomalies',
  'crm.reconciliation.paymentStatus': 'Payment Status',
  'crm.reconciliation.enabled': 'Enabled',
  'crm.reconciliation.disabled': 'Disabled',
  'crm.reconciliation.triggerManual': 'Run Manual Check',
  'crm.reconciliation.triggerSuccess': 'Reconciliation completed',
  'crm.reconciliation.triggerFailed': 'Reconciliation failed',
  'crm.reconciliation.refresh': 'Refresh',
  'crm.reconciliation.time': 'Time',
  'crm.reconciliation.walletBalance': 'Wallet Balance',
  'crm.reconciliation.threshold': 'Threshold',
  'crm.reconciliation.anomaly': 'Anomaly',
  'crm.reconciliation.action': 'Action',
  'crm.reconciliation.message': 'Message',
  'crm.reconciliation.yes': 'Yes',
  'crm.reconciliation.no': 'No',
  'crm.reconciliation.actionCheck': 'Check',
  'crm.reconciliation.actionAutoDisable': 'Auto Disable',
  'crm.reconciliation.actionAutoEnable': 'Auto Enable',
  'crm.reconciliation.addWithdrawal': 'Add Withdrawal',
  'crm.reconciliation.amount': 'Amount',
  'crm.reconciliation.currency': 'Currency',
  'crm.reconciliation.amountUsdt': 'Amount (USDT)',
  'crm.reconciliation.txHash': 'TX Hash',
  'crm.reconciliation.note': 'Note',
  'crm.reconciliation.delete': 'Delete',
  'crm.reconciliation.deleteConfirm':
    'Are you sure you want to delete this withdrawal record?',
  'crm.reconciliation.addSuccess': 'Withdrawal record added',
  'crm.reconciliation.addFailed': 'Failed to add withdrawal record',
  'crm.reconciliation.deleteSuccess': 'Withdrawal record deleted',
  'crm.reconciliation.deleteFailed': 'Failed to delete withdrawal record',

  // Unmatched Payments
  'crm.unmatchedPayments.title': 'Unmatched Payments',
  'crm.unmatchedPayments.list': 'Payment List',
  'crm.unmatchedPayments.total': 'Total',
  'crm.unmatchedPayments.pendingCount': 'Pending',
  'crm.unmatchedPayments.boundCount': 'Bound',
  'crm.unmatchedPayments.ignoredCount': 'Ignored',
  'crm.unmatchedPayments.paymentId': 'Payment ID',
  'crm.unmatchedPayments.paymentStatus': 'Payment Status',
  'crm.unmatchedPayments.payCurrency': 'Currency',
  'crm.unmatchedPayments.payAmount': 'Pay Amount',
  'crm.unmatchedPayments.actuallyPaid': 'Actually Paid',
  'crm.unmatchedPayments.priceAmount': 'Price Amount',
  'crm.unmatchedPayments.payAddress': 'Pay Address',
  'crm.unmatchedPayments.purchaseId': 'Purchase ID',
  'crm.unmatchedPayments.status': 'Status',
  'crm.unmatchedPayments.statusPending': 'Pending',
  'crm.unmatchedPayments.statusBound': 'Bound',
  'crm.unmatchedPayments.statusIgnored': 'Ignored',
  'crm.unmatchedPayments.createdAt': 'Received At',
  'crm.unmatchedPayments.boundOrderId': 'Bound Order',
  'crm.unmatchedPayments.actions': 'Actions',
  'crm.unmatchedPayments.bind': 'Bind to Order',
  'crm.unmatchedPayments.ignore': 'Ignore',
  'crm.unmatchedPayments.delete': 'Delete',
  'crm.unmatchedPayments.bindTitle': 'Bind Payment to Order',
  'crm.unmatchedPayments.bindOrderId': 'Order ID',
  'crm.unmatchedPayments.bindOrderIdPlaceholder':
    'Enter order ID (e.g. ORD20240126...)',
  'crm.unmatchedPayments.bindConfirm':
    'Are you sure to bind this payment to the specified order? This will fulfill the order and is irreversible.',
  'crm.unmatchedPayments.bindSuccess': 'Payment bound to order successfully',
  'crm.unmatchedPayments.ignoreTitle': 'Ignore Payment',
  'crm.unmatchedPayments.ignoreNote': 'Note (optional)',
  'crm.unmatchedPayments.ignoreNotePlaceholder': 'Reason for ignoring...',
  'crm.unmatchedPayments.ignoreSuccess': 'Payment ignored',
  'crm.unmatchedPayments.deleteConfirm': 'Are you sure to delete this record?',
  'crm.unmatchedPayments.deleteSuccess': 'Deleted',
  'crm.unmatchedPayments.outcomeAmount': 'Outcome Amount',
  'crm.unmatchedPayments.fee': 'Fee',

  // System Admin - Accounts
  'crm.system.accountList': 'Admin Accounts',
  'crm.system.createAccount': 'Create Account',
  'crm.system.editAccount': 'Edit Account',
  'crm.system.deleteAccountConfirm':
    'Are you sure to delete this admin account?',
  'crm.system.username': 'Username',
  'crm.system.password': 'Password',
  'crm.system.newPassword': 'New Password',
  'crm.system.role': 'Role',
  'crm.system.selectRole': 'Select a role',
  'crm.system.avatar': 'Avatar',
  'crm.system.superAdmin': 'Super Admin',
  'crm.system.resetPassword': 'Reset Password',
  'crm.system.resetPasswordSuccess': 'Password reset successfully',

  // System Admin - Roles
  'crm.system.roleList': 'Role List',
  'crm.system.createRole': 'Create Role',
  'crm.system.editRole': 'Edit Role',
  'crm.system.deleteRoleConfirm':
    'Are you sure to delete this role? Make sure no accounts are using it.',
  'crm.system.roleName': 'Role Name',
  'crm.system.description': 'Description',
  'crm.system.permissions': 'Permissions',
  'crm.system.permissionCount': 'Permissions',
  'crm.system.adminCount': 'Linked Accounts',
  'crm.system.systemRole': 'System',

  // Permission tree labels
  'crm.perm.dashboard': 'Dashboard',
  'crm.perm.dashboard:view': 'View Dashboard',
  'crm.perm.dashboard:edit': 'Edit ROI Cost',
  'crm.perm.users': 'User Management',
  'crm.perm.users:view': 'View Users',
  'crm.perm.users:edit': 'Edit User Status',
  'crm.perm.users:adjustBalance': 'Adjust Balance',
  'crm.perm.users:grantMiner': 'Grant Miner',
  'crm.perm.miners': 'Miner Management',
  'crm.perm.miners:view': 'View Miners',
  'crm.perm.miners:create': 'Create Miner Product',
  'crm.perm.miners:edit': 'Edit Miner Product',
  'crm.perm.miners:delete': 'Delete Miner Product',
  'crm.perm.orders': 'Order Management',
  'crm.perm.orders:view': 'View Orders',
  'crm.perm.tickets': 'Ticket Management',
  'crm.perm.tickets:view': 'View Tickets',
  'crm.perm.tickets:create': 'Create Ticket',
  'crm.perm.tickets:edit': 'Edit Ticket',
  'crm.perm.tickets:delete': 'Delete Ticket',
  'crm.perm.withdrawals': 'Withdrawal Management',
  'crm.perm.withdrawals:view': 'View Withdrawals',
  'crm.perm.withdrawals:approve': 'Approve / Reject',
  'crm.perm.activities': 'Activity Management',
  'crm.perm.activities:view': 'View Activities',
  'crm.perm.activities:manage': 'Manage Activities',
  'crm.perm.analytics': 'Data Analytics',
  'crm.perm.analytics:view': 'View Analytics',
  'crm.perm.channels': 'Channel Statistics',
  'crm.perm.channels:view': 'View Channels',
  'crm.perm.payments': 'Payment Management',
  'crm.perm.payments:view': 'View Payments',
  'crm.perm.payments:manage': 'Manage Payments',
  'crm.perm.reconciliation': 'Reconciliation',
  'crm.perm.reconciliation:view': 'View Reconciliation',
  'crm.perm.reconciliation:manage': 'Manage Reconciliation',
  'crm.perm.transactions': 'Transaction Records',
  'crm.perm.transactions:view': 'View Transactions',
  'crm.perm.messages': 'Message Management',
  'crm.perm.messages:view': 'View Messages',
  'crm.perm.messages:send': 'Send Messages',
  'crm.perm.messages:delete': 'Delete Messages',
  'crm.perm.settings': 'System Settings',
  'crm.perm.settings:view': 'View Settings',
  'crm.perm.settings:edit': 'Edit Settings',
  'crm.perm.system': 'System Admin',
  'crm.perm.system:accounts': 'Manage Accounts',
  'crm.perm.system:roles': 'Manage Roles',

  // Promotions
  'crm.promotions.title': 'Promotions',
  'crm.promotions.create': 'Create Promotion',
  'crm.promotions.edit': 'Edit Promotion',
  'crm.promotions.name': 'Name',
  'crm.promotions.product': 'Target Product',
  'crm.promotions.discount': 'Discount (%)',
  'crm.promotions.requiredQty': 'Required Quantity',
  'crm.promotions.duration': 'Duration (Days)',
  'crm.promotions.launchDate': 'Launch Date',
  'crm.promotions.isActive': 'Status',
  'crm.promotions.usageCount': 'Usage Count',
  'crm.promotions.active': 'Active',
  'crm.promotions.inactive': 'Inactive',
  'crm.promotions.deleteConfirm': 'Are you sure to delete this promotion?',
  'crm.promotions.deleteSuccess': 'Deleted',
  'crm.promotions.createSuccess': 'Created',
  'crm.promotions.updateSuccess': 'Updated',
  'crm.promotions.toggleSuccess': 'Status toggled',
  'crm.promotions.selectProduct': 'Select Product',
  'crm.promotions.namePlaceholder': 'e.g. Limited 50% OFF',
  'crm.promotions.discountTip': 'Enter discount percentage, e.g. 50 = 50% off',
  'crm.promotions.targetUsers': 'Target Users',
  'crm.promotions.targetOld': 'Old Users',
  'crm.promotions.targetNew': 'New Users',
  'crm.promotions.targetAll': 'All Users',
  'crm.promotions.targetUsersTip':
    'Old: registered before launch date; New: registered after launch date',
  'crm.promotions.ruleDesc':
    'Rule: Buy {qty}x {product}, get {discount}% off. Once per user, valid {days} days from registration.',

  // Common
  'crm.refresh': 'Refresh',
  'crm.actions': 'Actions',

  // Behavior Analytics
  'crm.analyticsEvents.title': 'Behavior Analytics',
  'crm.analyticsEvents.list': 'Event Stream',
  'crm.analyticsEvents.detail': 'Detail',
  'crm.analyticsEvents.anonymous': 'Anonymous',
  'crm.analyticsEvents.loadFailed': 'Failed to load',
  'crm.analyticsEvents.vsPrev': 'vs previous',
  'crm.analyticsEvents.range.today': 'Today',
  'crm.analyticsEvents.range.7d': 'Last 7 days',
  'crm.analyticsEvents.range.30d': 'Last 30 days',
  'crm.analyticsEvents.kpi.totalPv': 'Total PV',
  'crm.analyticsEvents.kpi.totalUv': 'Total UV',
  'crm.analyticsEvents.kpi.register': 'Sign-ups',
  'crm.analyticsEvents.kpi.login': 'Logins',
  'crm.analyticsEvents.kpi.startClick': 'Start-Mining Clicks',
  'crm.analyticsEvents.kpi.claimClick': 'Claim Clicks',
  'crm.analyticsEvents.kpi.avgDwell': 'Avg Page Dwell',
  'crm.analyticsEvents.trend.title': 'Event Trend',
  'crm.analyticsEvents.topPaths.title': 'Top Pages (PV)',
  'crm.analyticsEvents.topPaths.path': 'Path',
  'crm.analyticsEvents.topPaths.avgDwell': 'Avg Dwell',
  'crm.analyticsEvents.column.createdAt': 'Time',
  'crm.analyticsEvents.column.eventName': 'Event',
  'crm.analyticsEvents.column.user': 'User',
  'crm.analyticsEvents.column.uid': 'User UID',
  'crm.analyticsEvents.column.pagePath': 'Page Path',
  'crm.analyticsEvents.column.dwell': 'Dwell Time',
  'crm.analyticsEvents.column.country': 'Country',
  'crm.analyticsEvents.column.ip': 'IP',
  'crm.analyticsEvents.column.referrer': 'Referrer',
  'crm.analyticsEvents.column.keyword': 'Keyword (Anon/IP/UA)',
  'crm.analyticsEvents.column.dateRange': 'Date Range',
  'crm.analyticsEvents.event.page_view': 'Page View',
  'crm.analyticsEvents.event.page_leave': 'Page Leave',
  'crm.analyticsEvents.event.user_login': 'Login',
  'crm.analyticsEvents.event.user_register_success': 'Sign-up',
  'crm.analyticsEvents.event.mining_first': 'First Mining',
  'crm.analyticsEvents.event.mining_start_click': 'Start Mining Click',
  'crm.analyticsEvents.event.mining_claim_click': 'Claim Click',
  // Home
  'crm.analyticsEvents.event.home_avatar_click': 'Home · Open Drawer (Avatar)',
  'crm.analyticsEvents.event.home_btc_balance_click':
    'Home · Click BTC Balance',
  'crm.analyticsEvents.event.home_pwa_install_click':
    'Home · Click PWA Install',
  'crm.analyticsEvents.event.home_hashrate_upgrade_click':
    'Home · Hashrate UPGRADE',
  'crm.analyticsEvents.event.home_my_miners_view': 'Home · View Miner Detail',
  'crm.analyticsEvents.event.home_add_miner_click': 'Home · Click Add Miner',
  // Drawer
  'crm.analyticsEvents.event.drawer_support_click': 'Drawer · Click Support',
  'crm.analyticsEvents.event.drawer_language_click': 'Drawer · Click Language',
  // Activity
  'crm.analyticsEvents.event.activity_daily_pool_join_click':
    'Activity · Daily Pool Join Now',
  'crm.analyticsEvents.event.activity_share_copy_link_click':
    'Activity · Share Copy Link',
  'crm.analyticsEvents.event.activity_share_platform_click':
    'Activity · Share Platform',
  'crm.analyticsEvents.event.activity_install_reward_claim_click':
    'Activity · Install Reward Claim',
  // Market
  'crm.analyticsEvents.event.market_buy_now_click': 'Market · Click Buy Now',
  'crm.analyticsEvents.event.market_confirm_qty_increase_click':
    'Market · Confirm Qty Increase',
  'crm.analyticsEvents.event.market_confirm_payment_method_select':
    'Market · Confirm Payment Method',
  'crm.analyticsEvents.event.market_confirm_continue_click':
    'Market · Confirm Continue',
  'crm.analyticsEvents.event.market_swiper_next_click':
    'Market · Swiper Next Arrow',
  // Team
  'crm.analyticsEvents.event.team_how_commission_click':
    'Team · How Commission Works',
  'crm.analyticsEvents.event.team_copy_link_click': 'Team · Copy Referral Link',
  'crm.analyticsEvents.event.team_share_click': 'Team · Share',
  'crm.analyticsEvents.event.team_level_select': 'Team · Level Select',
  // Assets
  'crm.analyticsEvents.event.assets_withdraw_click': 'Assets · Click Withdraw',

  // User detail · Behavior Tab
  'crm.users.behaviorTab': 'Behavior',
};
